import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=335959b4&scoped=true&"
import script from "./MessageCard.vue?vue&type=script&lang=ts&"
export * from "./MessageCard.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=335959b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335959b4",
  null
  
)

export default component.exports